
import qs from 'qs'

const fields = [
]

export const queryOnlineExhibitionEntryThumbnails = (options: QueryManyOptions) => {
  const sortKey = strapiGetI18nSortKey(options?.locale, 'titles.i18n_string')

  const query = qs.stringify(
    {
      publicationState: options?.publicationState || 'live',
      sort: options?.sort || [`${sortKey}:asc`],
      pagination: {
        page: options?.page || 1,
        pageSize: options?.pageSize || 4,
      },
      fields,
      populate: {
        ...queryFragmentCollectionTypeDefault,
        images: {
          populate: {
            image: true,
            descriptions: true
          }
        }
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `online-exhibition-entries?${query}`
}
